var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTumbleDryer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6 2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2m1 2a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m3 0a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m2 4a6 6 0 0 0-6 6a6 6 0 0 0 6 6a6 6 0 0 0 6-6a6 6 0 0 0-6-6m-3.89 2.5H10c-.24 1.38 0 2.17.58 2.79c1.1 1.07 1.58 2.42 1.31 4.21H10c.24-1.38 0-2.17-.58-2.79c-1.1-1.07-1.57-2.42-1.31-4.21m4 0H14c-.24 1.38 0 2.17.58 2.79c1.1 1.07 1.58 2.42 1.31 4.21H14c.24-1.38 0-2.17-.58-2.79c-1.1-1.07-1.57-2.42-1.31-4.21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTumbleDryer);
export default __webpack_public_path__ + "static/media/tumble-dryer.ac684e945cd9cf5da5bb8342bb62fe89.svg";
export { ForwardRef as ReactComponent };